import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Pagination from "react-js-pagination";
import Loading from "../Loading/Loading";
import YesNoModal from "../Modal/YesNoModal";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../Header/RightMenu";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
const Convertible = () => {
    const [data, setDate] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [removeModal, setRemoveModal] = useState(false);
    const [removeProductId, setRemoveProductId] = useState(undefined);

    const [cookies, setCookie, removeCookie] = useCookies();
    const [filters, setFilters] = useState([
        {
            key: "prodName_fa",
            value: null
        },
        {
            key: "pack",
            value: null
        },
        {
            key: "packStock",
            value: null
        },
        {
            key: "stock",
            value: null
        }
    ]);
    const [state, setState] = useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    function getData(page) {
        let filterUrl = "";
        filters.map((item) => {
            if (item.value != null)
                filterUrl += `filter[${item.key}]=${item.value}&`
        })
        const url = Constants.apiUrl + "/api/query/convertible" + "?page=" + page + "&" + filterUrl;
        axios
            .get(
                url,
                { page: page },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);

            })
            .catch((e) => {
                console.log("ERROR IS ", e);

            });

    }

    useEffect(() => {
        setLoading(true);
        getData(1);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(1);
    }, [filters]);

    function filter(e) {
        let key = e.target.name;
        let value = e.target.value;

        const newFilter = filters.map(obj => {
            if (obj.key == key) {
                return { ...obj, value: value };
            }
            return obj;
        });
        setFilters(newFilter)
        getData(1, filters);
    }
    function remove() {
        setLoading(true);
        const url = Constants.apiUrl + "/api/query/set-convertible";
        axios
            .post(
                url,
                { productId: removeProductId },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                getData(data.data.current_page);
                setRemoveModal(false);

            })
            .catch((e) => {
                console.log("ERROR IS ", e);

            });
        setLoading(false);

    }


    return (
        <React.Fragment>

<Breadcrumb title={"  بسته های قابل تبدیل  "} />

            {console.log("RM", removeModal)}
            {loading ? <Loading /> : ""}
            {removeModal ? <YesNoModal massage={"یا از انجام این عملیات اطمینان دارید"} no={() => { setRemoveModal(false) }} yes={remove} /> : ""}

            <div className="container-fluid">
                <table className="table table-hover ">
                    <thead className="">
                        <tr className="bg-danger text-white">
                            <th scope="col">تصویر</th>
                            <th scope="col">نام محصول</th>
                            <th scope="col">نام بسته</th>
                            <th scope="col">موجودی بسته</th>
                            <th scope="col">موجودی محصول</th>
                            <th scope="col">غیر قابل تبدیل</th>

                        </tr>
                        <tr className="bg-danger text-white">
                            <th scope="col"> </th>
                            <th scope="col">
                                <input name={"prodName_fa"} onChange={filter} />
                            </th>
                            <th scope="col">
                                <input name={"pack"} onChange={filter} />
                            </th>
                            <th scope="col">
                                <input name={"packStock"} onChange={filter} />
                            </th>
                            <th scope="col">
                                <input name={"stock"} onChange={filter} />
                            </th>
                            <th scope="col"> </th>


                        </tr>

                    </thead>

                    <tbody>
                        {data &&
                            data.data &&
                            Object.values(data.data).map((item, index) => {
                                return (
                                    <tr>
                                        <th scope="row">
                                            <a href={Constants.oldAdminUrl + "/products/update/" + item.id}>
                                                <img src={Constants.imagesBsaeUrl + '/image/resizeTest/shop/_600x/thumb_' + item.prodID + '.jpg'} style={{ width: '50px', height: '50px', borderRadius: '2px', cursor: "pointer" }} />

                                            </a>
                                        </th>
                                        <th scope="row">
                                            <a href={Constants.siteUrl + "/" + item.url}>

                                                {item.prodName_fa}
                                            </a>
                                        </th>
                                        <th scope="row">
                                            {item.pack.map((pack) => (<>
                                                {pack.label}
                                                <hr />
                                            </>))}
                                        </th>
                                        <th scope="row">
                                            {item.pack.map((pack) => (<>
                                                <a href={Constants.oldAdminUrl + "/depack/create?packId=" + pack.id + "&productId=" + item.id}>
                                                    {pack.stock}
                                                </a>
                                                <hr />
                                            </>))}
                                        </th>
                                        <th scope="row">
                                            {item.stock}
                                        </th>
                                        <th scope="row">
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setRemoveModal(true);
                                                    setRemoveProductId(item.id);
                                                }}
                                            >
                                                X
                                            </button>

                                        </th>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                <div className="pager Page navigation example">
                    {data && (
                        <Pagination
                            totalItemsCount={data.total}
                            activePage={data.current_page}
                            itemsCountPerPage={data.per_page}
                            onChange={(number) => {
                                setLoading(true);
                                getData(number);
                                setLoading(false);

                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass="pageactive"
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};
export default Convertible;
